export default __webpack_public_path__ + "static/media/map_notification.9811cd4b.svg";